import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import logo from "../img/logo.png";
import "./styles/FrontPage.css";

export default function StartPage(props) {
  async function handleLogin(data) {
    await fetch(
      `https://${process.env.REACT_APP_HOSTNAME}/user/${data.email}`,
      {
        method: "POST",
      }
    );
    localStorage.setItem("loginState", "true");
    localStorage.setItem("userId", data.email);
    props.SetLoginStatus("true");
    props.SetUser(data.email);
  }

  function handleFailure(result) {
    alert(result.error);
    localStorage.setItem("loginState", "false");
    localStorage.setItem("userId", "null");
    props.SetLoginStatus("false");
    props.SetUser("null");
  }

  return (
    <div className="startDiv">
      {/* <div className="Logo"> Welcome to GameRater</div> */}

      <img className="animate" src={logo} alt="" />
      <br />
      <br />
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <GoogleLogin
          className="googleButton"
          onSuccess={(credResponse) => {
            // handleLogin(data);
            const respdecoded = jwtDecode(credResponse.credential);
            handleLogin(respdecoded);
          }}
          onError={(error) => {
            console.log("Login Failed");
            handleFailure(error);
          }}
        />
      </div>
      <br />
      <button onClick={props.onGuestLogin} className="guestLoginButton">
        Continue as Guest
      </button>
    </div>
  );
}
